import React from 'react';
interface CTAButtonProps {
  text: string;
  isCheckout?: boolean;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  text,
  isCheckout = false,
  className = '',
  onClick
}: CTAButtonProps) {
  const baseStyles = 'flex items-center justify-center w-full min-h-[52px] bg-petroleo text-white font-semibold rounded-xl px-6 py-3 transition-transform active:scale-95 hover:bg-opacity-90 shadow-lg';
  if (isCheckout) {
    return <a href="https://biologiafemenina.com.ar/checkouts/cn/hWNAZSgw69FMqj8K5JzSARhS/en-ar?_r=AQABnlLqQ012_A3hL8PvkCwsiXgReYZ5ojjVujWohyp1z2E" className={`${baseStyles} ${className}`} onClick={onClick} data-id="element-26">
        {text}
      </a>;
  }
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onClick) onClick();
    const target = document.getElementById('comprar');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <button onClick={handleClick} className={`${baseStyles} ${className}`} data-id="element-27">
      {text}
    </button>;
}